import { Message, proto3 } from '@bufbuild/protobuf';
/**
 * @generated from enum plugnmeet.DataMsgType
 */
export var DataMsgType;
(function (DataMsgType) {
    /**
     * @generated from enum value: USER = 0;
     */
    DataMsgType[DataMsgType["USER"] = 0] = "USER";
    /**
     * @generated from enum value: SYSTEM = 1;
     */
    DataMsgType[DataMsgType["SYSTEM"] = 1] = "SYSTEM";
    /**
     * @generated from enum value: WHITEBOARD = 2;
     */
    DataMsgType[DataMsgType["WHITEBOARD"] = 2] = "WHITEBOARD";
})(DataMsgType || (DataMsgType = {}));
// Retrieve enum metadata with: proto3.getEnumType(DataMsgType)
proto3.util.setEnumType(DataMsgType, 'plugnmeet.DataMsgType', [
    { no: 0, name: 'USER' },
    { no: 1, name: 'SYSTEM' },
    { no: 2, name: 'WHITEBOARD' },
]);
/**
 * @generated from enum plugnmeet.DataMsgBodyType
 */
export var DataMsgBodyType;
(function (DataMsgBodyType) {
    /**
     * SYSTEM type
     *
     * @generated from enum value: RAISE_HAND = 0;
     */
    DataMsgBodyType[DataMsgBodyType["RAISE_HAND"] = 0] = "RAISE_HAND";
    /**
     * @generated from enum value: LOWER_HAND = 1;
     */
    DataMsgBodyType[DataMsgBodyType["LOWER_HAND"] = 1] = "LOWER_HAND";
    /**
     * @generated from enum value: OTHER_USER_LOWER_HAND = 2;
     */
    DataMsgBodyType[DataMsgBodyType["OTHER_USER_LOWER_HAND"] = 2] = "OTHER_USER_LOWER_HAND";
    /**
     * @generated from enum value: FILE_UPLOAD = 3;
     */
    DataMsgBodyType[DataMsgBodyType["FILE_UPLOAD"] = 3] = "FILE_UPLOAD";
    /**
     * @generated from enum value: INFO = 4;
     */
    DataMsgBodyType[DataMsgBodyType["INFO"] = 4] = "INFO";
    /**
     * @generated from enum value: ALERT = 5;
     */
    DataMsgBodyType[DataMsgBodyType["ALERT"] = 5] = "ALERT";
    /**
     * @generated from enum value: SEND_CHAT_MSGS = 6;
     */
    DataMsgBodyType[DataMsgBodyType["SEND_CHAT_MSGS"] = 6] = "SEND_CHAT_MSGS";
    /**
     * @generated from enum value: RENEW_TOKEN = 7;
     */
    DataMsgBodyType[DataMsgBodyType["RENEW_TOKEN"] = 7] = "RENEW_TOKEN";
    /**
     * @generated from enum value: UPDATE_LOCK_SETTINGS = 8;
     */
    DataMsgBodyType[DataMsgBodyType["UPDATE_LOCK_SETTINGS"] = 8] = "UPDATE_LOCK_SETTINGS";
    /**
     * @generated from enum value: INIT_WHITEBOARD = 9;
     */
    DataMsgBodyType[DataMsgBodyType["INIT_WHITEBOARD"] = 9] = "INIT_WHITEBOARD";
    /**
     * @generated from enum value: USER_VISIBILITY_CHANGE = 10;
     */
    DataMsgBodyType[DataMsgBodyType["USER_VISIBILITY_CHANGE"] = 10] = "USER_VISIBILITY_CHANGE";
    /**
     * @generated from enum value: EXTERNAL_MEDIA_PLAYER_EVENTS = 11;
     */
    DataMsgBodyType[DataMsgBodyType["EXTERNAL_MEDIA_PLAYER_EVENTS"] = 11] = "EXTERNAL_MEDIA_PLAYER_EVENTS";
    /**
     * @generated from enum value: POLL_CREATED = 12;
     */
    DataMsgBodyType[DataMsgBodyType["POLL_CREATED"] = 12] = "POLL_CREATED";
    /**
     * @generated from enum value: NEW_POLL_RESPONSE = 13;
     */
    DataMsgBodyType[DataMsgBodyType["NEW_POLL_RESPONSE"] = 13] = "NEW_POLL_RESPONSE";
    /**
     * @generated from enum value: POLL_CLOSED = 14;
     */
    DataMsgBodyType[DataMsgBodyType["POLL_CLOSED"] = 14] = "POLL_CLOSED";
    /**
     * @generated from enum value: JOIN_BREAKOUT_ROOM = 15;
     */
    DataMsgBodyType[DataMsgBodyType["JOIN_BREAKOUT_ROOM"] = 15] = "JOIN_BREAKOUT_ROOM";
    /**
     * @generated from enum value: SPEECH_SUBTITLE_TEXT = 23;
     */
    DataMsgBodyType[DataMsgBodyType["SPEECH_SUBTITLE_TEXT"] = 23] = "SPEECH_SUBTITLE_TEXT";
    /**
     * @generated from enum value: AZURE_COGNITIVE_SERVICE_SPEECH_TOKEN = 24;
     */
    DataMsgBodyType[DataMsgBodyType["AZURE_COGNITIVE_SERVICE_SPEECH_TOKEN"] = 24] = "AZURE_COGNITIVE_SERVICE_SPEECH_TOKEN";
    /**
     * @generated from enum value: UPDATE_ROOM_METADATA = 25;
     */
    DataMsgBodyType[DataMsgBodyType["UPDATE_ROOM_METADATA"] = 25] = "UPDATE_ROOM_METADATA";
    /**
     * USER type
     *
     * @generated from enum value: CHAT = 16;
     */
    DataMsgBodyType[DataMsgBodyType["CHAT"] = 16] = "CHAT";
    /**
     * WHITEBOARD type
     *
     * @generated from enum value: SCENE_UPDATE = 17;
     */
    DataMsgBodyType[DataMsgBodyType["SCENE_UPDATE"] = 17] = "SCENE_UPDATE";
    /**
     * @generated from enum value: POINTER_UPDATE = 18;
     */
    DataMsgBodyType[DataMsgBodyType["POINTER_UPDATE"] = 18] = "POINTER_UPDATE";
    /**
     * @generated from enum value: ADD_WHITEBOARD_FILE = 19;
     */
    DataMsgBodyType[DataMsgBodyType["ADD_WHITEBOARD_FILE"] = 19] = "ADD_WHITEBOARD_FILE";
    /**
     * @generated from enum value: ADD_WHITEBOARD_OFFICE_FILE = 20;
     */
    DataMsgBodyType[DataMsgBodyType["ADD_WHITEBOARD_OFFICE_FILE"] = 20] = "ADD_WHITEBOARD_OFFICE_FILE";
    /**
     * @generated from enum value: PAGE_CHANGE = 21;
     */
    DataMsgBodyType[DataMsgBodyType["PAGE_CHANGE"] = 21] = "PAGE_CHANGE";
    /**
     * @generated from enum value: WHITEBOARD_APP_STATE_CHANGE = 22;
     */
    DataMsgBodyType[DataMsgBodyType["WHITEBOARD_APP_STATE_CHANGE"] = 22] = "WHITEBOARD_APP_STATE_CHANGE";
    /**
     * analytics
     *
     * @generated from enum value: ANALYTICS_DATA = 27;
     */
    DataMsgBodyType[DataMsgBodyType["ANALYTICS_DATA"] = 27] = "ANALYTICS_DATA";
})(DataMsgBodyType || (DataMsgBodyType = {}));
// Retrieve enum metadata with: proto3.getEnumType(DataMsgBodyType)
proto3.util.setEnumType(DataMsgBodyType, 'plugnmeet.DataMsgBodyType', [
    { no: 0, name: 'RAISE_HAND' },
    { no: 1, name: 'LOWER_HAND' },
    { no: 2, name: 'OTHER_USER_LOWER_HAND' },
    { no: 3, name: 'FILE_UPLOAD' },
    { no: 4, name: 'INFO' },
    { no: 5, name: 'ALERT' },
    { no: 6, name: 'SEND_CHAT_MSGS' },
    { no: 7, name: 'RENEW_TOKEN' },
    { no: 8, name: 'UPDATE_LOCK_SETTINGS' },
    { no: 9, name: 'INIT_WHITEBOARD' },
    { no: 10, name: 'USER_VISIBILITY_CHANGE' },
    { no: 11, name: 'EXTERNAL_MEDIA_PLAYER_EVENTS' },
    { no: 12, name: 'POLL_CREATED' },
    { no: 13, name: 'NEW_POLL_RESPONSE' },
    { no: 14, name: 'POLL_CLOSED' },
    { no: 15, name: 'JOIN_BREAKOUT_ROOM' },
    { no: 23, name: 'SPEECH_SUBTITLE_TEXT' },
    { no: 24, name: 'AZURE_COGNITIVE_SERVICE_SPEECH_TOKEN' },
    { no: 25, name: 'UPDATE_ROOM_METADATA' },
    { no: 16, name: 'CHAT' },
    { no: 17, name: 'SCENE_UPDATE' },
    { no: 18, name: 'POINTER_UPDATE' },
    { no: 19, name: 'ADD_WHITEBOARD_FILE' },
    { no: 20, name: 'ADD_WHITEBOARD_OFFICE_FILE' },
    { no: 21, name: 'PAGE_CHANGE' },
    { no: 22, name: 'WHITEBOARD_APP_STATE_CHANGE' },
    { no: 27, name: 'ANALYTICS_DATA' },
]);
/**
 * @generated from message plugnmeet.DataMessage
 */
export class DataMessage extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.DataMsgType type = 1;
         */
        this.type = DataMsgType.USER;
        /**
         * @generated from field: string room_sid = 3;
         */
        this.roomSid = '';
        /**
         * @generated from field: string room_id = 4;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DataMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DataMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DataMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DataMessage, a, b);
    }
}
DataMessage.runtime = proto3;
DataMessage.typeName = 'plugnmeet.DataMessage';
DataMessage.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'type', kind: 'enum', T: proto3.getEnumType(DataMsgType) },
    {
        no: 2,
        name: 'message_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 3, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'to',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 6, name: 'body', kind: 'message', T: DataMsgBody },
]);
/**
 * @generated from message plugnmeet.DataMsgBody
 */
export class DataMsgBody extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.DataMsgBodyType type = 1;
         */
        this.type = DataMsgBodyType.RAISE_HAND;
        /**
         * @generated from field: string msg = 5;
         */
        this.msg = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DataMsgBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DataMsgBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DataMsgBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DataMsgBody, a, b);
    }
}
DataMsgBody.runtime = proto3;
DataMsgBody.typeName = 'plugnmeet.DataMsgBody';
DataMsgBody.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'type',
        kind: 'enum',
        T: proto3.getEnumType(DataMsgBodyType),
    },
    {
        no: 2,
        name: 'message_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 3,
        name: 'time',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 4, name: 'from', kind: 'message', T: DataMsgReqFrom },
    { no: 5, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 6,
        name: 'is_private',
        kind: 'scalar',
        T: 13 /* ScalarType.UINT32 */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.DataMsgReqFrom
 */
export class DataMsgReqFrom extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sid = 1;
         */
        this.sid = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DataMsgReqFrom().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DataMsgReqFrom().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DataMsgReqFrom().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DataMsgReqFrom, a, b);
    }
}
DataMsgReqFrom.runtime = proto3;
DataMsgReqFrom.typeName = 'plugnmeet.DataMsgReqFrom';
DataMsgReqFrom.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'name',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
